export function has (items, key) {
	return key in items;
}
